import { post } from "@/tools/require.js";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

/* eslint-disable no-new */
const store = new Vuex.Store({
  state: {
    loading: 0,
    carousels: null,
    news_categories: null,
    news_list: null,
    news_page: null,
    knowledge_categories: null,
    knowledge_list: null,
    knowledge_page: null,
    reviews: null,
    doctors: null,
    theme_columns: null,
    page_meta: null,
    work_hours: null,
    service_list: null,
    gallery: null,
  },
  getters: {
    getImageUrl: () => (item) => {
      return item == "" ? "" : process.env.VUE_APP_BASE_API + item;
    },
    getThemeColumn:
      (state) =>
      (key, full = false) => {
        const column = state.theme_columns.find(
          (column) => column.ColumnKey == key
        );

        if (column) {
          return full ? column : column.Content;
        }
        return "";
      },
  },
  mutations: {
    setLoading(state, count) {
      const newCount = state.loading + count;
      state.loading = newCount < 0 ? 0 : newCount;
    },
    setStateData(state, { key, val }) {
      state[key] = val;
    },
    setPageData(state, data) {
      Object.keys(data).forEach((currentKey) => {
        if (currentKey == "theme_columns" && state.theme_columns != null) {
          //合併元有資料
          state.theme_columns = state.theme_columns.concat(data.theme_columns);
          //去除重複資料
          state.theme_columns = Array.from(new Set(state.theme_columns));
        } else if (data[currentKey] != null) {
          state[currentKey] = data[currentKey];
        } else if (state[currentKey] != null && state[currentKey].data) {
          state[currentKey].data = [];
        } else if (["news_page", "knowledge_page"].indexOf(currentKey) != -1) {
          state[currentKey] = null;
        } else {
          state[currentKey] = [];
        }
      });
    },
  },
  actions: {
    getBasePageData(state) {
      // apiKeyList
      let data = {};
      Object.keys(window.global_data).forEach((key) => {
        data[key] = window.global_data[key];
      });

      state.commit("setPageData", data);
    },
    // 取得當前頁面資料
    getPageData({ commit }, params) {
      return new Promise((resolve, reject) => {
        post("/page_data", params)
          .then((response) => {
            commit("setPageData", response.data);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
});

export default store;
